import cn from 'classnames';
import * as React from 'react';

import { ReactComponent as CloseIcon } from '../../../assets/images/icon-close-cross.svg';
import { BUTTON_BUTTON } from '../../../types/forms';
import { ActionButton } from '../../forms';
import ModalActions from '../ModalActions/ModalActions';
import ModalHeader from '../ModalHeader/ModalHeader';

import styles from './CommonModals.module.scss';

interface IProps {
  onClose: () => void;
  onSubmit: () => void;
}

const FulfillmentCentersNavigationModal: React.FC<IProps> = ({ onClose, onSubmit }) => (
  <div className={cn(styles.container)}>
    <ModalHeader
      className={styles.header}
      right={
        <button type={BUTTON_BUTTON} onClick={onClose}>
          <CloseIcon className={styles.closeBtn} />
        </button>
      }
    />
    <div className={styles.content}>
      <h1 className={styles.contentHeader}>Confirm Navigation</h1>
      <div className={styles.description}>
        <p>Are you sure you want to change the fulfillment center?</p>
        <p>Your added items will be lost</p>
      </div>
    </div>
    <ModalActions className={styles.footer}>
      <ActionButton title="Leave this center" onClick={onSubmit} outlined />
      <ActionButton title="Stay on this center" onClick={onClose} />
    </ModalActions>
  </div>
);

export default FulfillmentCentersNavigationModal;
